import { object } from '@/core/utils/validation';
import { blockedItemIdsSchema, pickingItemSchema, taskSchema } from './SocketMessageBase.yup';
const returnedFromBlockToPickingMessageSchema = object({
    task: taskSchema.required(),
    pickingItem: pickingItemSchema.required(),
    blockedItemIds: blockedItemIdsSchema.required(),
}).noUnknown(true);
export { returnedFromBlockToPickingMessageSchema };
